import React, { memo, useEffect, useState } from 'react';

import { Input } from 'common/materials';

type Props = {
    value?: string;
    placeholder?: string;
    onSubmit?: (searchKey: string) => void;
}

function SearchInput(props: Props) {
    const { value, placeholder, onSubmit } = props;

    const [searchKey, setSearchKey] = useState('');

    useEffect(() => {
        if (value !== searchKey) {
            setSearchKey(value || '');
        }
    }, [value]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchKey(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSubmit?.(searchKey);
    };

    return (
        <form onSubmit={handleSubmit}>
            <Input
                type="text"
                placeholder={placeholder ?? 'Search...'}
                className="italic focus:not-italic xl:min-w-[280px]"
                onChange={handleChange}
            />
        </form>
    );
}

export default memo(SearchInput);
